(function () {
  var NUDGE_KEY = 'md-habba-nudge-dismissed';
  var WELCOME_KEY = 'md-habba-welcome';
  var SALE_END = Date.parse('2026-09-14T23:59:59+05:30');

  function saleActive() {
    return !SALE_END || Date.now() < SALE_END;
  }

  function initNudge() {
    var el = document.querySelector('[data-habba-nudge]');
    if (!el || !saleActive()) return;
    if (localStorage.getItem(NUDGE_KEY) === '1') return;
    el.hidden = false;
    var close = el.querySelector('[data-habba-nudge-close]');
    if (close) {
      close.addEventListener('click', function () {
        localStorage.setItem(NUDGE_KEY, '1');
        el.hidden = true;
      });
    }
  }

  function burst(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    canvas.width = Math.floor(vw * dpr);
    canvas.height = Math.floor(vh * dpr);
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var colors = ['#e8c36a', '#c4121a', '#fff7e6', '#f3d48a', '#8b1a1f', '#ffd97a', '#ffffff'];
    var mobile = vw < 768;
    var n = mobile ? 110 : 180;
    var parts = [];
    var cx = vw / 2;
    var cy = vh * 0.42;

    function spawn(kind) {
      var angle, speed;
      if (kind === 'fountain') {
        angle = -Math.PI / 2 + (Math.random() - 0.5) * 1.4;
        speed = 3.5 + Math.random() * 5.5;
        return {
          x: cx + (Math.random() - 0.5) * 40,
          y: cy,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          g: 0.12 + Math.random() * 0.08
        };
      }
      if (kind === 'side') {
        var left = Math.random() < 0.5;
        return {
          x: left ? -10 : vw + 10,
          y: Math.random() * vh * 0.55,
          vx: (left ? 1 : -1) * (2.2 + Math.random() * 3.2),
          vy: -1.5 - Math.random() * 2.8,
          g: 0.1
        };
      }
      return {
        x: Math.random() * vw,
        y: -12 - Math.random() * 140,
        vx: -1.4 + Math.random() * 2.8,
        vy: 1.6 + Math.random() * 2.8,
        g: 0.06
      };
    }

    for (var i = 0; i < n; i++) {
      var kind = i % 5 === 0 ? 'side' : (i % 2 === 0 ? 'fountain' : 'rain');
      var s = spawn(kind);
      var shapeRoll = Math.random();
      parts.push({
        x: s.x,
        y: s.y,
        vx: s.vx,
        vy: s.vy,
        g: s.g,
        rot: Math.random() * Math.PI * 2,
        vr: -0.18 + Math.random() * 0.36,
        c: colors[i % colors.length],
        w: 3 + Math.random() * 8,
        hh: 2 + Math.random() * 4,
        shape: shapeRoll > 0.72 ? 'circle' : (shapeRoll > 0.45 ? 'ribbon' : 'rect'),
        delay: Math.random() * 900
      });
    }

    var duration = 5200;
    var start = performance.now();
    function frame(t) {
      var elapsed = t - start;
      ctx.clearRect(0, 0, vw, vh);
      var fade = elapsed > duration - 900 ? Math.max(0, (duration - elapsed) / 900) : 1;
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        if (elapsed < p.delay) continue;
        p.vy += p.g;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.c;
        ctx.globalAlpha = fade * 0.92;
        if (p.shape === 'circle') {
          ctx.beginPath();
          ctx.arc(0, 0, p.w * 0.45, 0, Math.PI * 2);
          ctx.fill();
        } else if (p.shape === 'ribbon') {
          ctx.fillRect(-p.w, -1, p.w * 2, 2.2);
        } else {
          ctx.fillRect(-p.w / 2, -p.hh / 2, p.w, p.hh);
        }
        ctx.restore();
      }
      if (elapsed < duration) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function initWelcome() {
    if (!saleActive()) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (sessionStorage.getItem(WELCOME_KEY) === '1') return;
    var root = document.querySelector('[data-habba-welcome]');
    if (!root) return;
    sessionStorage.setItem(WELCOME_KEY, '1');
    root.hidden = false;
    var canvas = root.querySelector('[data-habba-confetti]');
    if (canvas) burst(canvas);
    setTimeout(function () {
      root.classList.add('is-out');
      setTimeout(function () { root.hidden = true; }, 750);
    }, 4800);
  }

  function boot() {
    initNudge();
    initWelcome();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
